import { PartTypeSchema } from "../types";

export const getIsMachiningFromPartType = (partType: string | null): boolean => {
  return partType === PartTypeSchema.enum.MACHINING || partType === null;
};
